import { cn } from "@omni/utils/styles";

import { usePriceContext } from "@/components/Price/context/price.context";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    className?: string;
};

export const Main = ({ className }: Props) => {
    const { price, size } = usePriceContext();

    const [wholePrice, decimalPrice] = formatPrice(price, {
        zeroAsDash: true
    }).split(",");

    return (
        <span
            className={cn(
                "tw:font-bold tw:text-danger tw:block tw:w-fit",
                {
                    "tw:leading-2": size === "xs",
                    "tw:leading-4": size === "sm",
                    "tw:leading-6": size === "md",
                    "tw:leading-8": size === "lg",
                    "tw:leading-10": size === "xl"
                },
                className
            )}
        >
            <span
                className={cn({
                    "tw:text-sm": size === "xs",
                    "": size === "sm",
                    "tw:text-xl": size === "md",
                    "tw:text-2xl": size === "lg",
                    "tw:text-4xl": size === "xl"
                })}
            >
                {wholePrice}
                {","}
            </span>
            <span
                className={cn({
                    "tw:text-[0.7rem]": size === "xs",
                    "tw:text-xs": size === "sm",
                    "tw:text-sm": size === "md",
                    "": size === "lg",
                    "tw:text-2xl": size === "xl"
                })}
            >
                {decimalPrice}
            </span>
        </span>
    );
};
